import axios from 'axios'
import { Message } from 'element-ui'
import { getToken, clearAuth } from '@/utils/auth'
import router from '@/router'
import { getApiBase, USE_MOCK, API_PROXY_TARGET } from '@/config/api'

const service = axios.create({
  timeout: 15000
})

function redirectToLogin() {
  clearAuth()
  if (router.currentRoute.path !== '/login') {
    router.push('/login')
  }
}

function resolveErrorMessage(err) {
  const status = err.response && err.response.status
  const body = err.response && err.response.data
  const bodyMsg = body && (body.message || body.title)
  const apiBase = getApiBase()
  if (bodyMsg) return bodyMsg
  if (body && body.errors && typeof body.errors === 'object') {
    const msgs = Object.values(body.errors).flat().filter(Boolean)
    if (msgs.length) return msgs.join('；')
  }
  if (status === 401) return '登录已过期，请重新登录'
  if (err.message && err.message.includes('ECONNREFUSED')) {
    return `无法连接后端 API，请先启动 AcApi（${API_PROXY_TARGET}）`
  }
  if (err.message && err.message.includes('Network Error')) {
    return `网络错误，请确认 API 地址：${apiBase}`
  }
  return err.message || '网络错误'
}

service.interceptors.request.use(config => {
  config.baseURL = getApiBase()
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

service.interceptors.response.use(
  res => {
    const data = res.data
    if (data && typeof data.code !== 'undefined' && data.code !== 0) {
      Message.error(data.message || '请求失败')
      if (data.code === 401) {
        redirectToLogin()
      }
      return Promise.reject(new Error(data.message || '请求失败'))
    }
    return data
  },
  err => {
    const status = err.response && err.response.status
    if (status === 401) {
      redirectToLogin()
    }
    Message.error(resolveErrorMessage(err))
    return Promise.reject(err)
  }
)

export { USE_MOCK, getApiBase as API_BASE }
export default service
